import { useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import {  ONBOARDING_STORAGE_KEY } from './useOnboardingState';

export const useOnboardingPersistence = () => {
  const loadOnboardingState = useCallback(async () => {
    try {
      const { data } = await supabase.auth.getUser();
      if (!data.user) {
        return { user: null, savedState: null, isSetupCompleted: false };
      }

      const savedState = localStorage.getItem(`${ONBOARDING_STORAGE_KEY}_${data.user.id}`);
      let parsedState = null;
      
      if (savedState) {
        parsedState = JSON.parse(savedState);
      }

      const { data: profileData, error } = await supabase
        .from('profiles')
        .select('setup_completed')
        .eq('id', data.user.id)
        .single();
      
      const isSetupCompleted = !error && profileData?.setup_completed === true;
      
      return {
        user: data.user,
        savedState: parsedState,
        isSetupCompleted
      };
    } catch (error) {
      console.error('Error loading onboarding state:', error);
      return { user: null, savedState: null, isSetupCompleted: false };
    }
  }, []);

  const updateSetupCompleted = useCallback(async (userId: string, completed: boolean) => {
    if (!userId) return;
    
    try {
      const { error } = await supabase
        .from('profiles')
        .update({ setup_completed: completed })
        .eq('id', userId);
      
      if (error) {
        console.error('Error updating setup completion:', error);
      }
    } catch (error) {
      console.error('Error updating setup completion:', error);
    }
  }, []);

  return {
    loadOnboardingState,
    updateSetupCompleted
  };
};
